<template>
  <div class="reports">
    <layout-logged-frame title="Reports" has-before>
      <template v-slot:content>
        <v-card class="pa-4 elevation-0">
          <h2 v-if="!isDealLoading" class="mb-4 d-flex align-center">
            <router-link class="mr-1" :to="{ path: '/reports', query: $route.query }">
              <v-icon class="pa-2 text-secondary">
                chevron_left
              </v-icon>
            </router-link>
            <span class="reports-single__title">
              {{ title[0] }}
            </span>
          </h2>
          <v-skeleton-loader v-else type="heading" min-height="40" class="mb-4"></v-skeleton-loader>

          <div class="reports-before-content mb-4">
            <v-skeleton-loader
                v-if="isEngagementsLoading"
                type="table-cell"
                class="reports-before-content__loader"
            />
            <template v-else>{{ $t('updated') + ' ' + updatedAt }}</template>
          </div>

          <div class="d-flex gap-16 mb-6">
            <Metrics
                icon="chat"
                title="Comments"
                outlined
                :is-loading="isEngagementsLoading"
                :engagements="engagements"
            >
              {{ engagements?.comments }}
            </Metrics>
          </div>

          <div class="d-flex full single-report-chart-wrap">
            <ReportsChart
                :data="chartSummary"
                :is-loading="isChartSummaryLoading"
                :deal="deal[0] || {}"
                is-full
            />
          </div>
        </v-card>

        <ReportsTable
            class="pb-4"
            :items="deal"
            :pagination="pagination"
            has-no-footer
            :is-loading="isDealLoading"
        />

        <!--hidden until we get right data-->
        <Comments
            v-if="false"
            :data="deal[0]"
            :is-loading="isDealLoading"
        />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
import ReportsChart from '../../components/charts/Reports';
import Metrics from "../../components/panels/reports/Metrics.vue";
import defaultPagination from '../../config/pagination';
import Comments from "../../components/panels/reports/Comments.vue";
import ReportsTable from "../../components/table/reports/Index.vue";

export default {
  components: {
    ReportsChart,
    ReportsTable,
    Metrics,
    Comments
  },
  data() {
    return {
      threadId: this.$route.params.id,
      isEngagementsLoading: false,
      isDealLoading: false,
      isChartSummaryLoading: false,
      defaultPagination,
      pagination: {
        ...this.defaultPagination,
      },
      query: {},
    };
  },
  computed: {
    engagements() {
      const val = this.$store.getters['reports/engagementsSingle'];
      if (val?.length) {
        return val[0];
      }
      return null;
    },
    updatedAt() {
      return this.engagements?.updated_at ?
          this.$dayjs(this.engagements.updated_at).fromNow()
          : '';
    },
    deal() {
      return this.$store.getters['reports/deal'];
    },
    chartSummary() {
      return this.$store.getters['reports/chartSummary'];
    },
    title() {
      if (this.deal.length) {
        return this.deal[0].title;
      }
      return '';
    },
  },
  created() {
    this.query = {
      thread_id: this.threadId,
    };

    this.getDeal();
    this.getEngagements();
    this.getChartSummary();
  },
  methods: {
    getEngagements() {
      this.isEngagementsLoading = true;
      return this.$store
          .dispatch('reports/getEngagementsSingle', this.query)
          .finally(() => {
            this.isEngagementsLoading = false;
          });
    },
    getDeal() {
      this.isDealLoading = true;
      return this.$store
          .dispatch('reports/getDeal', this.query)
          .finally(() => {
            this.isDealLoading = false;
          });
    },
    getChartSummary() {
      this.isChartSummaryLoading = true;
      return this.$store
          .dispatch('reports/getChartSummary', this.query)
          .finally(() => {
            this.isChartSummaryLoading = false;
          });
    },
  },
};
</script>

<style lang="scss">
@use 'sass:map';
@use "../../assets/styles/theme" as *;

.reports-single__title {
  font-size: 18px;
  font-weight: 700;
}

.reports-before-content {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: map.get($colors, text-muted) !important;
}

.reports-before-content__loader {
  height: 18px;

  .v-skeleton-loader__table-cell {
    height: auto;
  }
}

.single-report-chart-wrap {
  border: 1px solid #e5e5e5;
  border-radius: $border-radius;
  height: 487px;
}
</style>
